import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '@/hooks/useTheme';

export function Toaster() {
  const { isDark } = useTheme();

  return (
    <SonnerToaster
      theme={isDark ? 'dark' : 'light'}
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'bg-card border-brand-border/20 text-foreground shadow-lg',
          title: 'text-foreground font-medium',
          description: 'text-muted',
          actionButton: 'bg-brand text-white',
          cancelButton: 'bg-brand-soft text-foreground',
        },
      }}
    />
  );
}
